import { render, staticRenderFns } from "./articles.vue?vue&type=template&id=7fc66d38&scoped=true"
import script from "./articles.vue?vue&type=script&lang=js"
export * from "./articles.vue?vue&type=script&lang=js"
import style0 from "./articles.vue?vue&type=style&index=0&id=7fc66d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc66d38",
  null
  
)

export default component.exports